import { csvParse } from "d3-dsv";
// eslint-disable-next-line import/no-webpack-loader-syntax
import worldSummary from "!!raw-loader!./WorldSummary.csv";

const data = csvParse(worldSummary);

data.forEach((row) => (row["0.5"] = +row["0.5"]));

export default data;
